import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/w/product-types/')({
  validateSearch: validateTableSearch,
});
